var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketServiceImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272.797,
    height: 142.926,
    viewBox: "0 0 272.797 142.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;fill:url(#a);}.b{opacity:0.4;fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:#9970f8;}.h{fill:#e5dcfa;}.i{fill:#a581f8;}.j{fill:#b29beb;}.k{fill:url(#g);}.l{fill:#fff;}.m{fill:#e7dcfa;}.n{fill:#dad0f2;}.o,.p,.q,.r{opacity:0.6;}.o{fill:url(#h);}.p{fill:url(#i);}.q{fill:url(#j);}.r{fill:url(#k);}.s{fill:#d5c9f2;}.t{fill:#382079;}.u{fill:#e64577;}.v{fill:#fa6e9a;}.w{fill:#5131a3;}.x{fill:#ece3fa;}.y{fill:#ffbe91;}.z{fill:#eb8e6c;}.aa{fill:#c3b8d4;}.ab{fill:#ae9dbf;}.ac{fill:url(#n);}.ad{fill:#fa7da4;}.ae{fill:#7054c7;}.af{fill:#c8bbf0;}.ag{opacity:0.65;fill:url(#o);}.ah{fill:#2d1861;}.ai{fill:#e8875a;}.aj{fill:#e32e67;}.ak{fill:#f7f2ff;}.al{fill:#cf275c;}.am{fill:#f7ae7c;}.an{fill:#ed9e68;}.ao{fill:#db7b4f;}.ap{fill:#fa3e79;}.aq{fill:#f7a97c;}.ar{fill:#a070f8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.251,
    y1: 1.657,
    x2: 0.735,
    y2: 0.009,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9b9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.14,
    y1: 1.599,
    x2: 0.816,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa3e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d453af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b863d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a66cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a070f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.393,
    y1: 2.319,
    x2: 1.216,
    y2: -1.203,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0adff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0adff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.209,
    y1: 2.92,
    x2: 0.882,
    y2: -0.589,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.384,
    y1: 1.186,
    x2: 0.815,
    y2: -0.993,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.244,
    y1: 2.399,
    x2: 0.716,
    y2: -0.809,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.158,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#613ec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6947c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7d5fd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9e87e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5b5fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa3e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa3e79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -0.287,
    y1: 1.618,
    x2: 0.688,
    y2: 0.233,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f3ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.5,
    y1: 1.254,
    x2: 0.5,
    y2: -0.19,
    xlinkHref: "#h"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.385 5.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.359,122.757c-2.264,10.185-16.333,12.215-7.076,33.778h242.2c-4.358-7-18.4-13.414-41.044-13.191-24.169.237-36.171-15.142-38.865-24.347-2.838-9.666-1.154-20.652-13.007-31.626-5.413-5.009-17.148-5.54-18.447-16.7-.738-6.34,1.6-12.6-.351-20.991-2.171-9.377-13.042-20.547-34.813-17.341-21.539,3.172-36.62,21.392-46.417,20.459-9.086-.87-18.771.608-23.847,7.235-5.932,7.736-3.239,13.524-5.1,20.47-2.728,10.185-14.012,9.666-14.067,24.544C89.486,111.775,91.389,118.125,90.359,122.757Z",
    transform: "translate(-80.163 -31.78)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.535)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M246.986,189.6c-25.251-2.234-34.9,7.724-55.816-4.749-14.655-8.737-5.368-30.49-24.16-46.05-5.8-4.8-22.638-8.447-24.109-19.034-.835-6.011,3.194-22.426-6.3-28.458-24.023-15.259-45.694,15.551-80.633,12.5-11.549-1.01-19.791,3.061-24,9.245-4.3,6.315-3.436,13.4-6.679,21.564C21.439,144.291,5.861,149.341,0,163.026v28.7a72.211,72.211,0,0,0,5.53,10.853H272.8C271.1,197.424,259.269,190.691,246.986,189.6Z",
    transform: "translate(0 -87.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.417 49.256)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M324.649,295H313.93v32.517c2.671.334,6.071-2.338,6.65-4.106,1.236-3.775,3.279-5.485,5.906-4.69V306.2h-1.837Z",
    transform: "translate(-313.93 -295)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.698 47.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M733.3,282h-.469v5.56h-8.988V305.8h-2.488V295.369H716.89v15.077c4.525-1.7,3.413,3.211,6.746,4.253,2.526.79,9.106-6.1,11.83-4.121V287.56h-2.171Z",
    transform: "translate(-716.89 -282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.158 56.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.719,338.47H67.25v3.939H57.372v16.73h-3.85v-2.181l-6.178-4.623-6.178,4.623v2.179h-8.3V368.3H24.9v16.734a10.255,10.255,0,0,1,7.25,2.171c2.2,1.615,4.87,2.366,6.762,1.962,2.371-.5,3.283-1.686,4.57-3.819,1.311-2.171,2.793-3.927,5.156-3.987a8.517,8.517,0,0,1,4.293.982c1.608.788,3.126,1.531,4.657,1.316,1.249-.167,1.655-1.568,2.085-3.041.578-1.982,1.234-4.226,4.159-3.725,2.4.411,3.231-1.646,4.112-3.824.571-1.413,1.159-2.854,2.209-3.591V342.41H67.719Z",
    transform: "translate(-24.9 -338.47)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.248 65.825)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M889.489,414.752v-4.573l-5.948-4.445-5.946,4.445v4.573H874.7V394.23H862.33v11.354h-4.4V415.8h8.36v8.786c3.172,1.448,5.51-.493,7.131-1.362,4.69-2.5,7.265,0,9.728,1.723,2.059,1.444,4.366,3.8,8.265,2.558,5.816-1.857,5.941,2.727,9.684,2.727V414.752Z",
    transform: "translate(-857.93 -394.23)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M381.327,825.247c0,1.969-11.265,2.945-33.183,3.263-11.466.167-25.015.317-38.294-.277-13.219-.593-32.976.431-39.79.431-26.745,0-40.729-1.875-40.729-3.66,0-1.481,21.681-1.514,48.421-1.514S381.327,822.1,381.327,825.247Z",
    transform: "translate(-191.039 -685.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M227.418,111.214l.08-.252,4.156-4.082-1.785-.566-5.617,2.12-5.74-1.822,10.327-7.089-1.768-.593-15.951,5.335-8.348-2.651a3.84,3.84,0,0,0-2.394.022l-1.122.377a.633.633,0,0,0,.012,1.2l22.384,7.1Z",
    transform: "translate(-165.627 -82.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M290.426,101.683l-11.045,7.63-6.111-1.97,15.718-6.173Z",
    transform: "translate(-227.642 -84.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M353.084,159.184l-3.717,1.393-4.1-1.3,6.468-.518Z",
    transform: "translate(-287.621 -132.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M207.987,114.767l-.06.389-2.067-.538.362-.122a3.661,3.661,0,0,1,.473-.127Z",
    transform: "translate(-171.488 -95.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M293.09,120.4l-3.723-1.409c-.334-.105-.771.334-.97.962s-.089,1.237.247,1.336l3.862.972c.267.083.616-.267.776-.781S293.354,120.483,293.09,120.4Z",
    transform: "translate(-240.161 -99.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M227.373,127.575l.08-.252-3.956-.952-24.583-7.8a.629.629,0,0,0,.292,1l22.384,7.1Z",
    transform: "translate(-165.581 -98.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M294.823,128.214c-.2.065-.167.3-.561.314a10.017,10.017,0,0,1-2.416-.578.606.606,0,0,0-.723.265c-.222.386-.529.608-.783.528l3.862.972c.267.083.616-.267.776-.781C295.005,128.848,295.089,128.129,294.823,128.214Z",
    transform: "translate(-241.862 -106.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M110.642,502.054c-3.932-2.646-8.961-9.684-7.891-14.685.468-2.179,2.937-2.431,4.754-2.431.778,0,1.546.053,2.224.1.529.037,1.02.07,1.411.07.6,0,.7-.085.716-.112.733-1.221.7-2.945.678-4.612-.03-1.713-.057-3.339.8-4.188a4.943,4.943,0,0,1,3.673-1.6,9.439,9.439,0,0,1,2.687.467,5.914,5.914,0,0,0,1.67.272,2.575,2.575,0,0,0,1.344-.317,1.748,1.748,0,0,0,.71-1.913c-.043-.287-.1-.568-.149-.835-.289-1.5-.559-2.925,1.336-3.829a3.135,3.135,0,0,1,1.321-.224c.2,0,.411,0,.616.015s.406.015.6.015a1.977,1.977,0,0,0,1.241-.292,3.2,3.2,0,0,0,1.017-2.54c.012-.264.02-.556.028-.868V464.5c.11-3.879.317-11.1,4.987-12.6a4.508,4.508,0,0,1,1.4-.214,11.329,11.329,0,0,1,3.361.718,12.245,12.245,0,0,0,3.7.77h.3c1.324-.065,2-1.416,2.718-2.838.91-1.813,1.942-3.867,4.558-3.867h.094v.369h-.094c-2.338,0-3.273,1.855-4.174,3.65-.771,1.534-1.5,2.984-3.079,3.064-.114,0-.227.008-.334.008a12.646,12.646,0,0,1-3.814-.786,10.964,10.964,0,0,0-3.236-.7,4.049,4.049,0,0,0-1.254.189c-4.4,1.421-4.605,8.477-4.714,12.267-.01.334-.018.64-.028.918a3.505,3.505,0,0,1-1.147,2.793,2.374,2.374,0,0,1-1.539.394c-.2,0-.406,0-.608-.015s-.4-.015-.6-.015a2.728,2.728,0,0,0-1.12.179c-1.63.778-1.416,1.892-1.122,3.431.053.281.109.569.154.865a2.073,2.073,0,0,1-.887,2.266,3.03,3.03,0,0,1-1.585.382,6.382,6.382,0,0,1-1.808-.291,8.866,8.866,0,0,0-2.555-.452,4.489,4.489,0,0,0-3.339,1.484c-.748.748-.721,2.3-.695,3.937.028,1.715.057,3.486-.726,4.79-.13.217-.459.309-1.1.309-.394,0-.872-.033-1.426-.07-.7-.048-1.479-.1-2.242-.1-2.616,0-3.979.678-4.291,2.134-1.04,4.864,3.885,11.731,7.734,14.321l.1.068-.3.267Z",
    transform: "translate(-85.473 -371.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M781.813,489.9l.1-.068c2.3-1.5,6.245-4.784,6.433-7.529a2.64,2.64,0,0,0-1.084-2.319,4.2,4.2,0,0,0-2.518-.531c-.925,0-1.979.09-3.005.179-1.065.092-2.07.179-2.967.179a5.165,5.165,0,0,1-2.254-.367c-1.169-.583-1.511-2.135-1.867-3.779-.471-2.184-.958-4.443-3.339-4.882a5.725,5.725,0,0,0-1.03-.1c-2.747,0-4.864,2.1-6.731,3.959-1.611,1.6-3.127,3.107-4.852,3.107a3.081,3.081,0,0,1-1.2-.252c-.857-.361-.321-2.411.783-6.306,1.322-4.66,3.131-11.042.857-12.868a2.606,2.606,0,0,0-1.7-.521,5.507,5.507,0,0,0-.641.042c-2.855.351-4.715,2.282-6.355,3.986-1.451,1.5-2.7,2.808-4.353,2.808a3.7,3.7,0,0,1-1.685-.439c-1.862-.938-2.161-3.767-2.45-6.5-.249-2.338-.484-4.562-1.646-5.315a4.189,4.189,0,0,0-2.348-.685,9.789,9.789,0,0,0-2.04.28,8.207,8.207,0,0,1-1.67.239,2.17,2.17,0,0,1-1.942-1c-.875-1.282,1-2.822,2.813-4.311,1.272-1.045,2.588-2.126,2.311-2.717-.107-.227-.533-.529-1.96-.678-2.171-.227-2.306-1.534-2.433-2.8-.12-1.212-.245-2.466-1.93-3.219a4.885,4.885,0,0,0-2-.379,22.137,22.137,0,0,0-6.31,1.463,22.466,22.466,0,0,1-6.5,1.494,5.209,5.209,0,0,1-2.5-.558c-.967-.514-1.2-1.5-1.473-2.636-.389-1.635-.835-3.486-3.7-4.341l-.11-.032.179-.347.075.023c3.1.93,3.593,2.979,3.986,4.625.252,1.054.469,1.964,1.276,2.393a4.741,4.741,0,0,0,2.276.5,22.27,22.27,0,0,0,6.345-1.468,22.424,22.424,0,0,1,6.468-1.488,5.313,5.313,0,0,1,2.211.422c1.9.845,2.039,2.266,2.171,3.52s.225,2.267,2.05,2.458c1.352.142,2.087.431,2.311.91.391.835-.908,1.9-2.413,3.134-1.611,1.324-3.436,2.823-2.738,3.84a1.733,1.733,0,0,0,1.565.825,8.043,8.043,0,0,0,1.558-.232,10.325,10.325,0,0,1,2.151-.289,4.635,4.635,0,0,1,2.6.763c1.317.852,1.561,3.149,1.818,5.582.281,2.64.569,5.368,2.237,6.21a3.214,3.214,0,0,0,1.461.386c1.448,0,2.638-1.237,4.017-2.672,1.691-1.756,3.608-3.747,6.629-4.117a5.62,5.62,0,0,1,.693-.045,3.122,3.122,0,0,1,2.014.621c2.461,1.979.691,8.222-.73,13.237-.75,2.638-1.6,5.63-1.015,5.876a2.6,2.6,0,0,0,1.017.212c1.516,0,2.9-1.378,4.508-2.974,1.933-1.92,4.119-4.092,7.054-4.092a6.28,6.28,0,0,1,1.134.107c2.672.491,3.2,2.982,3.673,5.176.334,1.555.653,3.024,1.655,3.521a4.868,4.868,0,0,0,2.045.314c.89,0,1.917-.089,2.91-.167,1.029-.089,2.092-.18,3.036-.18a4.551,4.551,0,0,1,2.827.631,2.982,2.982,0,0,1,1.222,2.62c-.2,2.882-4.246,6.263-6.605,7.807l-.062.038Z",
    transform: "translate(-590.211 -360.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M99.95,414.481v-.459h8.809V397.031h11.529l0,5.266h3.3V392.75l9.389,0,0,17.944h-.431l0-17.487-8.529,0v9.517h-4.163l0-5.236H109.188v16.991Z",
    transform: "translate(-83.261 -327.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M727.8,368.51V358.031l-9.6,0v7.615h-3.259V351.274H709.9V350.8h5.441v14.371h2.439v-7.617l10.424,0V368.51Z",
    transform: "translate(-591.369 -292.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M892.049,495.45V485.182h-7.477l0-10.571-7.423,0v8h-4.64V482.2h4.231v-8l8.243,0,0,10.571h7.479V495.45Z",
    transform: "translate(-726.828 -395.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M315.4,349.586v-30.2h10.511v10.973H327.8v.416h-2.3V319.848h-9.689v29.739Z",
    transform: "translate(-262.738 -266.061)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 53.654,
    height: 103.18,
    rx: 26.827,
    transform: "translate(64.973 36.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 49.526,
    height: 99.053,
    rx: 20.95,
    transform: "translate(67.036 38.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M451.008,236.4v6.372H401.48V236.4a3.506,3.506,0,0,1,3.5-3.5H447.51A3.506,3.506,0,0,1,451.008,236.4Z",
    transform: "translate(-334.445 -194.012)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 42.09,
    height: 0.294,
    transform: "translate(70.753 63.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.271,325.261a.205.205,0,0,1-.205-.205v-.262a2.76,2.76,0,0,1-1.012-.235.2.2,0,0,1-.1-.249l.1-.294a.205.205,0,0,1,.194-.139.217.217,0,0,1,.092.02,2.195,2.195,0,0,0,.922.21c.5,0,.825-.212.825-.556,0-.262-.127-.457-.771-.668-.554-.167-1.294-.5-1.294-1.264a1.225,1.225,0,0,1,1.045-1.155v-.259a.207.207,0,0,1,.205-.205h.334a.207.207,0,0,1,.205.205v.2a2.446,2.446,0,0,1,.816.167.205.205,0,0,1,.109.262l-.11.286a.2.2,0,0,1-.19.132.216.216,0,0,1-.08-.017,1.9,1.9,0,0,0-.746-.149c-.5,0-.73.237-.73.473,0,.282.2.441.82.651s1.252.531,1.252,1.306a1.288,1.288,0,0,1-1.14,1.227v.319a.205.205,0,0,1-.205.205Z",
    transform: "translate(-543.088 -266.569)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 53.447)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 12.925,
    height: 1.177,
    transform: "translate(78.874 55.469)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 19.135,
    height: 1.177,
    transform: "translate(78.874 57.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 42.09,
    height: 0.294,
    transform: "translate(70.753 77.685)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.271,410.734a.207.207,0,0,1-.205-.205v-.262a2.76,2.76,0,0,1-1.012-.235.2.2,0,0,1-.1-.249l.1-.294a.205.205,0,0,1,.194-.14.219.219,0,0,1,.092.022,2.2,2.2,0,0,0,.922.21c.5,0,.825-.214.825-.556,0-.262-.124-.466-.771-.676-.551-.18-1.294-.5-1.294-1.264a1.221,1.221,0,0,1,1.045-1.157v-.252a.205.205,0,0,1,.205-.205h.334a.205.205,0,0,1,.205.205v.2a2.364,2.364,0,0,1,.816.167.205.205,0,0,1,.109.262l-.11.284a.2.2,0,0,1-.19.132.215.215,0,0,1-.08-.015,1.892,1.892,0,0,0-.746-.15c-.5,0-.73.237-.73.472,0,.282.2.441.82.653s1.252.531,1.252,1.306a1.288,1.288,0,0,1-1.14,1.227v.319a.207.207,0,0,1-.205.205Z",
    transform: "translate(-543.088 -337.768)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 67.725)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 69.749)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 22.083,
    height: 1.177,
    transform: "translate(78.874 71.771)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 42.09,
    height: 0.294,
    transform: "translate(70.753 91.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.27,496.266a.205.205,0,0,1-.205-.205v-.26a2.8,2.8,0,0,1-1.012-.235.205.205,0,0,1-.1-.25l.1-.294a.207.207,0,0,1,.194-.139.2.2,0,0,1,.092.022,2.2,2.2,0,0,0,.922.21c.5,0,.825-.214.825-.556,0-.264-.124-.466-.771-.668-.551-.18-1.294-.5-1.294-1.264a1.221,1.221,0,0,1,1.045-1.157v-.257a.205.205,0,0,1,.205-.212h.334a.205.205,0,0,1,.205.205v.2a2.365,2.365,0,0,1,.817.167.205.205,0,0,1,.109.262l-.11.284a.2.2,0,0,1-.19.132.188.188,0,0,1-.08-.017,1.928,1.928,0,0,0-.746-.149c-.5,0-.73.237-.73.473,0,.282.2.441.82.653s1.252.529,1.252,1.306a1.29,1.29,0,0,1-1.14,1.227v.317a.205.205,0,0,1-.205.205Z",
    transform: "translate(-543.087 -409.018)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 82.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 17.181,
    height: 1.177,
    transform: "translate(78.874 84.026)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 24.484,
    height: 1.177,
    transform: "translate(78.874 86.048)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 42.09,
    height: 0.294,
    transform: "translate(70.753 106.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.7,582.3a.2.2,0,0,1-.2-.2v-.249a2.669,2.669,0,0,1-.962-.222.2.2,0,0,1-.1-.237l.1-.281a.194.194,0,0,1,.184-.132.221.221,0,0,1,.087.02,2.09,2.09,0,0,0,.877.2c.483,0,.783-.2.783-.528,0-.25-.119-.443-.733-.643-.524-.167-1.229-.469-1.229-1.2a1.164,1.164,0,0,1,.992-1.1v-.245a.2.2,0,0,1,.2-.2h.317a.2.2,0,0,1,.2.2v.187a2.278,2.278,0,0,1,.773.167.194.194,0,0,1,.1.249l-.1.271a.192.192,0,0,1-.182.125.187.187,0,0,1-.075-.015,1.811,1.811,0,0,0-.71-.142c-.478,0-.693.225-.693.449,0,.267.19.419.778.619s1.19.5,1.19,1.241a1.227,1.227,0,0,1-1.082,1.169v.3a.2.2,0,0,1-.2.2Z",
    transform: "translate(-543.502 -480.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 96.283)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 98.305)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 14.73,
    height: 1.177,
    transform: "translate(78.874 100.327)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 42.09,
    height: 0.294,
    transform: "translate(70.753 120.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.271,667.273a.205.205,0,0,1-.205-.205v-.262a2.76,2.76,0,0,1-1.012-.235.2.2,0,0,1-.1-.249l.1-.294a.205.205,0,0,1,.194-.139.215.215,0,0,1,.092.02,2.2,2.2,0,0,0,.922.21c.5,0,.825-.212.825-.556,0-.262-.124-.466-.771-.676-.551-.18-1.294-.5-1.294-1.264a1.219,1.219,0,0,1,1.045-1.155v-.259a.205.205,0,0,1,.205-.209h.334a.205.205,0,0,1,.205.205v.2a2.4,2.4,0,0,1,.816.167.205.205,0,0,1,.109.262l-.11.284a.2.2,0,0,1-.19.134.215.215,0,0,1-.08-.017,1.892,1.892,0,0,0-.746-.15c-.5,0-.73.237-.73.473,0,.282.2.441.82.653s1.252.531,1.252,1.306a1.288,1.288,0,0,1-1.14,1.227v.319a.205.205,0,0,1-.205.205Z",
    transform: "translate(-543.088 -551.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 22.118,
    height: 1.177,
    transform: "translate(78.874 110.561)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 112.584)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 19.353,
    height: 1.177,
    transform: "translate(78.874 114.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M653.271,752.81a.207.207,0,0,1-.205-.207v-.26a2.794,2.794,0,0,1-1.012-.235.2.2,0,0,1-.1-.249l.1-.3a.207.207,0,0,1,.194-.139.22.22,0,0,1,.092.022,2.194,2.194,0,0,0,.922.21c.5,0,.825-.214.825-.556,0-.264-.127-.458-.771-.676-.554-.167-1.294-.5-1.294-1.264A1.221,1.221,0,0,1,653.065,748v-.257a.205.205,0,0,1,.205-.205h.334a.205.205,0,0,1,.205.205v.205a2.361,2.361,0,0,1,.816.167.205.205,0,0,1,.109.262l-.11.284a.2.2,0,0,1-.19.132.187.187,0,0,1-.08-.017,1.926,1.926,0,0,0-.746-.149c-.5,0-.73.237-.73.472,0,.282.2.441.82.653s1.252.531,1.252,1.306a1.288,1.288,0,0,1-1.14,1.227v.317a.207.207,0,0,1-.205.207Z",
    transform: "translate(-543.088 -622.723)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 24.085,
    height: 1.177,
    transform: "translate(78.874 124.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 26.596,
    height: 1.177,
    transform: "translate(78.874 126.862)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 12.042,
    height: 1.177,
    transform: "translate(78.874 128.886)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.037 52.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M428.007,320.107a1.448,1.448,0,1,1,1.025-.423A1.448,1.448,0,0,1,428.007,320.107Zm0-4.007a2.553,2.553,0,0,0-1.925,4.231h0l1.925,2.313,1.927-2.313h0a2.555,2.555,0,0,0-1.927-4.231Z",
    transform: "translate(-425.453 -316.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.032 67.059)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M427.978,405.627A1.448,1.448,0,1,1,429,405.2,1.449,1.449,0,0,1,427.978,405.627Zm0-4.007a2.553,2.553,0,0,0-1.925,4.238h0l1.925,2.313,1.927-2.313h0a2.555,2.555,0,0,0-1.927-4.231Z",
    transform: "translate(-425.418 -401.62)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.037 81.338)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M428.007,491.147a1.449,1.449,0,1,1,1.449-1.449A1.449,1.449,0,0,1,428.007,491.147Zm0-4.007a2.553,2.553,0,0,0-1.925,4.231h0l1.925,2.314,1.927-2.314h0a2.555,2.555,0,0,0-1.927-4.231Z",
    transform: "translate(-425.453 -487.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.036 95.615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M428,576.657a1.448,1.448,0,1,1,1.025-.423A1.448,1.448,0,0,1,428,576.657Zm0-4.007a2.553,2.553,0,0,0-1.925,4.233h0L428,579.2l1.927-2.312h0A2.555,2.555,0,0,0,428,572.652Z",
    transform: "translate(-425.444 -572.65)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.037 109.895)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M428.007,662.177a1.448,1.448,0,1,1,1.025-.423A1.449,1.449,0,0,1,428.007,662.177Zm0-4.007a2.553,2.553,0,0,0-1.925,4.231h0l1.925,2.313,1.927-2.313h0a2.555,2.555,0,0,0-1.927-4.231Z",
    transform: "translate(-425.453 -658.17)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.037 124.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M428.007,747.7a1.449,1.449,0,1,1,1.449-1.449,1.449,1.449,0,0,1-1.449,1.449Zm0-4.007a2.553,2.553,0,0,0-1.925,4.231h0l1.925,2.314,1.927-2.314h0a2.555,2.555,0,0,0-1.927-4.231Z",
    transform: "translate(-425.453 -743.69)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 4.946,
    height: 0.798,
    transform: "translate(108.184 42.356)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 4.946,
    height: 0.798,
    transform: "translate(108.184 43.795)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 4.946,
    height: 0.798,
    transform: "translate(108.184 45.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M546.6,189.677c.878,2.59,1.648,5.271,2.338,7.9.219.835.282,3.291.974,3.89a2.244,2.244,0,0,0,1.883.334c1.249-.549.8-1.336.2-4.383-.461-2.329.068-5.472-.778-7.759-.212-.576-.518-1.336-.688-1.937-.2-.7.152-.728.7-1.117a8.789,8.789,0,0,1,2.787-1.227c1.237-.334,3.877-.863,4.209-2.546.294-1.494-1.55-2.985-2.763-3.349-1.5-.451-3.127.012-4.642.19-1.591.187-3.773-.067-5,1.231C544.224,182.606,545.225,185.612,546.6,189.677Z",
    transform: "translate(-454.004 -149.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M568.018,315.487a6.154,6.154,0,0,0,3.172-.865,3.467,3.467,0,0,0,.913-1.817c.255-.847.878-.835.334-1.76a3.676,3.676,0,0,0-1.431-1.456,3.436,3.436,0,0,0-1.625-.309c-.668.2-1.1.878-.963,1.97a5.138,5.138,0,0,1-.815,2.692C567.136,314.677,567.353,315.405,568.018,315.487Z",
    transform: "translate(-472.623 -257.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M530.146,317.37c.908-.3,1.436-1.155,2.055-1.95s1.538-1.767,1.381-2.984c-.124-.963-.511-.167-1.159-.129-.725.037-1.443-.69-2.171-.412s-1.127,1.67-1.718,2.271-1.8,1.284-2.338,1.962C524.35,318.473,529.433,317.6,530.146,317.37Z",
    transform: "translate(-438.004 -259.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M553.467,198.687a1.59,1.59,0,0,0,1.479,1.393,1.554,1.554,0,0,0,1.67-.519c.382-.559.167-2.621.5-3.84.569-2.1,4.032-4.842,4.547-9.729.287-2.718,6.493-.6,8.45-1.765,2.449-1.451,1.922-4.924.488-6.856-.743-1-4.358-.364-6.585.212-1.207.314-2.613.481-3.81.815a3.971,3.971,0,0,0-2.259,1.683c-.693,1.4-1.5,7.393-1.97,9.183C555.207,192.132,553.387,198.133,553.467,198.687Z",
    transform: "translate(-461.053 -147.317)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M585.9,85.407c.075.962.244,3.981,3.765,3.981,2.418,0,5.395.511,4.535-1.837a12.679,12.679,0,0,1-.835-2.142,8.091,8.091,0,0,1,.189-2.61,21.3,21.3,0,0,0,.115-5.9,15.7,15.7,0,0,1-.185-3.126c.117-1.478-.775-3.339-1.05-2.563a12.865,12.865,0,0,1-1.93,3.047c-1.149,1.269-2.9,1.1-3.339.07-.476-1.1-.142-1.912-.556-2.742-.367-.738-1.267,1.261-1.451,1.933a26.192,26.192,0,0,0-.85,6.266C584.276,81.814,585.748,83.425,585.9,85.407Z",
    transform: "translate(-486.746 -59.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M581.19,122.593c0,3.54,1.7,1.381,4.285,1.381s6.6,2,6.6-1.381c0-1.927-4.017-.107-6.6-.107S581.19,120.463,581.19,122.593Z",
    transform: "translate(-484.149 -101.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M574.713,78c.05.908-.307,2.187.788,2.5,1.419.407,1.423-1.2,1.356-2.159a21.138,21.138,0,0,1,.167-4.37,8.945,8.945,0,0,1,1.085-3.6c.239-.354,1.957-1.366,1.155-1.458a4.938,4.938,0,0,0-1.721.606,5.227,5.227,0,0,0-2.773,3.7A16.318,16.318,0,0,0,574.713,78Z",
    transform: "translate(-478.626 -57.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M593.068,28.612a1.787,1.787,0,0,0-1,1.643,4.017,4.017,0,0,0,.68,2.277,2.1,2.1,0,0,0,3.568.142c.5-.574,1.035-1.324,1.5-1.925a1.905,1.905,0,0,0,.534-1.815c-.24-.645-.953-.7-1.431-1.1-.624-.523-.356-1.19-.459-1.939.872.249.947-1.862.658-2.393a.334.334,0,0,0-.234-.105,2.636,2.636,0,0,0-1.847-2.838,3.354,3.354,0,0,0-3.565,1.372c-.5.912-.062,2,.028,2.967A4.868,4.868,0,0,0,593.068,28.612Z",
    transform: "translate(-492.52 -17.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M591.055,5.437a3.306,3.306,0,0,0-1.038-2.252.449.449,0,0,1-.043-.6,1.527,1.527,0,0,0-.4-2.186,2.811,2.811,0,0,0-2.57-.167c-1.361.7-.105,1.752-.184,1.97-.124.334-1.044.548-1.716,1.064-1.266.973-2.1,2.328-1.616,3.722.229.668,1.04,2.551,1.559,2.436.286-.063-.691-2.207,1.566-3.328.781-.387,1.992-.786,2.433.867.083.314.427,1.362.766,1.089.112-.088.028-.815.394-.987s.421.359.655.078A7.015,7.015,0,0,0,591.055,5.437Z",
    transform: "translate(-485.951 0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M568.182,83.226a2.479,2.479,0,0,0-.138,1.169c.11.411.883.877,1.226.745,1-.384.346-3.019.372-3.812a10.993,10.993,0,0,1,1.311-5.051c.371-.751.822-1.246.5-1.237-.279,0-.857.536-1.468,1.406a8.32,8.32,0,0,0-1.67,4.258C568.264,81.286,568.31,82.6,568.182,83.226Z",
    transform: "translate(-473.168 -62.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M601.37,66.094c0,.346.436,1.755,1.388,1.755s1.928-2.014,1.738-2.3-.571,1.129-1.738,1.129C601.559,66.685,601.37,65.76,601.37,66.094Z",
    transform: "translate(-500.96 -54.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M626.963,65.987c.82.534,1.037,3.925,1.087,5.022.055,1.221.155,2.439.2,3.662a16.492,16.492,0,0,1-.167,3.339,9.945,9.945,0,0,0-.451,2.778c.2,1.693,1.6,2.857,2.421,4.229.462.775,1.574,4.508,2.8,2.718.945-1.384.214-3.035-.04-4.264-.873-4.2.107-8.255-.466-12.513a5.858,5.858,0,0,0-2.06-3.994,13.829,13.829,0,0,0-3.864-1.633C625.883,65.2,626.839,65.907,626.963,65.987Z",
    transform: "translate(-521.694 -54.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M640.5,92.8c.6.7,1.58.085,2.224-.277,1.57-.882,2.638-1.217,2.793-3.253.073-.962-.322-1.955-.316-2.907a14.441,14.441,0,0,0-.144-3.366c-.478-2.254-2.116-6-3.43-5.649-.334.088-.559.815-.6,1.114a9.658,9.658,0,0,0,.458,3.032,8.531,8.531,0,0,1,.344,2.672c-.115,1-.775,1.878-.524,3.339.175,1.027.683,1.294.272,1.7-.376.374-1.528.913-1.6,1.521A2.743,2.743,0,0,0,640.5,92.8Z",
    transform: "translate(-533.099 -64.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M610.587,159.683c.276-.077,1.818-.549,2.354-.7a13.533,13.533,0,0,0,2.2-.668c1.187-.581.621-2.473-.621-2.6-.528-.053-.973.374-1.486.619-.6.284-1.877,1.05-2.488,1.307C606.727,159.244,609.161,160.082,610.587,159.683Z",
    transform: "translate(-506.9 -129.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M519.37,137.233h12.843l-3.7-8.761-12.845,0Z",
    transform: "translate(-429.569 -107.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M558.855,151.48a1.5,1.5,0,0,0,1.252.88c.488,0,.718-.394.513-.88a1.5,1.5,0,0,0-1.252-.88C558.88,150.6,558.65,151,558.855,151.48Z",
    transform: "translate(-465.481 -125.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M596.476,137.241h-.244l-3.712-8.761h.242Z",
    transform: "translate(-493.588 -107.027)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 12.501,
    height: 0.476,
    transform: "translate(102.888 30.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 5.093,
    height: 0.476,
    transform: "translate(102.888 30.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    width: 79.622,
    height: 32.352,
    rx: 9.49,
    transform: "translate(101.472 107.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M687.377,651.963V646.3a1.544,1.544,0,0,0-1.544-1.543H609.3a1.543,1.543,0,0,0-1.543,1.543v5.66Z",
    transform: "translate(-506.283 -537.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M949.641,677.125h-.511v-1.9h.511Zm0-3.805h-.511v-1.9h.511Zm0-3.807h-.511v-1.9h.511Zm0-3.807h-.511v-1.9h.511Zm0-3.805h-.511V660h.511Zm0-3.807h-.511v-1.9h.511Zm0-3.805h-.511v-1.9h.511Zm0-3.807h-.511v-1.9h.511Zm.022-3.8h-.511v-1.9h.511v1.15C949.666,646.188,949.664,646.443,949.663,646.679Z",
    transform: "translate(-790.655 -537.121)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 23.753,
    height: 1.955,
    rx: 0.978,
    transform: "translate(105.873 110.277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 23.412,
    height: 1.533,
    transform: "translate(130.575 119.926)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 19.681,
    height: 1.533,
    transform: "translate(130.575 123.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 23.412,
    height: 1.533,
    transform: "translate(130.575 127.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 17.453,
    height: 1.533,
    transform: "translate(130.575 130.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 14.346,
    height: 1.533,
    transform: "translate(162.842 119.926)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 8.075,
    height: 1.533,
    transform: "translate(162.842 123.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 14.346,
    height: 1.533,
    transform: "translate(162.842 127.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 12.132,
    height: 1.533,
    transform: "translate(162.842 130.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ae",
    cx: 10.021,
    cy: 10.021,
    r: 10.021,
    transform: "translate(101.723 127.291) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M661.569,732.948a.3.3,0,0,1-.1-.017c-.668-.252-1.877-.795-2.157-.922h-.194v.668a.267.267,0,0,1-.534,0v-.668H658.4c-.364.167-1.5.676-2.159.922a.3.3,0,0,1-.094.017.266.266,0,0,1-.267-.267v-.81a.267.267,0,0,1,.08-.189l1.837-1.807c-.033-.4-.137-1.631-.185-2.266-.97.314-2.267.755-3.318,1.11-.76.257-1.5.511-2.149.725a.252.252,0,0,1-.085.013.257.257,0,0,1-.155-.05.262.262,0,0,1-.112-.215v-.925a.264.264,0,0,1,.124-.224l5.677-3.665v-2.156a2.529,2.529,0,0,1,1.154-2.254l.067.073-.033-.092h.04a.146.146,0,0,1,.047,0,.242.242,0,0,1,.06,0l.048.017.027.013a2.529,2.529,0,0,1,1.139,2.247v2.156l5.677,3.665a.262.262,0,0,1,.122.224v.925a.264.264,0,0,1-.267.266h0a.278.278,0,0,1-.083-.012c-.646-.215-1.391-.467-2.149-.726-1.114-.377-2.369-.8-3.318-1.11-.05.634-.154,1.867-.187,2.266l1.837,1.807a.266.266,0,0,1,.078.189v.81a.267.267,0,0,1-.265.267Zm-5.158-.66c.76-.309,1.8-.783,1.813-.788a.291.291,0,0,1,.112-.022h.259v-1.773a.267.267,0,0,1,.534,0v1.773h.259a.269.269,0,0,1,.1.023c.012,0,1.055.479,1.817.788v-.311l-1.853-1.812a.267.267,0,0,1-.078-.212c0-.023.2-2.371.22-2.72a.266.266,0,0,1,.115-.2.279.279,0,0,1,.232-.033c.955.3,2.287.755,3.575,1.192l.225.075,1.643.556v-.409l-5.677-3.665a.266.266,0,0,1-.122-.224v-2.3a1.019,1.019,0,1,0-1.479,0v2.3a.262.262,0,0,1-.122.224l-5.677,3.665v.409l1.69-.571.105-.037c1.336-.449,2.672-.908,3.65-1.216a.259.259,0,0,1,.08-.012.269.269,0,0,1,.15.045.272.272,0,0,1,.117.2c.022.351.219,2.7.22,2.72a.267.267,0,0,1-.078.212l-1.833,1.812Z",
    transform: "translate(-542.961 -599.739)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.945 80.561)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ag",
    cx: 6.011,
    cy: 6.011,
    r: 6.011,
    transform: "translate(0 4.6) rotate(-22.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M534.938,516.037l-1.6-1.6a2.66,2.66,0,1,0-.473.472l1.6,1.6Zm-5.1-1.817a1.987,1.987,0,1,1,1.4.581,1.987,1.987,0,0,1-1.4-.581Z",
    transform: "translate(-440.323 -424.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M888.665,795.785a3.643,3.643,0,0,0,1.827.207,8.916,8.916,0,0,0,2.356-.259,11.873,11.873,0,0,0,1.892-1.284,23.6,23.6,0,0,0,2.6-1.534c.351-.271,1-.741.907-1.286-.167-.989-1.852-2.059-2.257-2.535a3.722,3.722,0,0,1-.594-1c-.073-.167-.11-.5-.249-.613-.443-.359-1.236.384-1.563.619-.451.322-1.122.576-1.423,1.027-.558.835-.5,2.154-.76,3.1a3.821,3.821,0,0,1-.748,1.5c-.468.541-1.06.548-1.641.912C888.575,794.911,888.251,795.447,888.665,795.785Z",
    transform: "translate(-740.126 -655.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M755.9,807.75h3.339a.881.881,0,0,0,.935-.561c.222-.668-.194-2.885-.177-3.49.013-.526.167-1.132-.212-1.535a2.262,2.262,0,0,0-1.7-.568c-1.092.129-1.992,1.15-2.822,1.768a9.683,9.683,0,0,1-3.4,1.514c-.835.22-2.2.222-2.2,1.356C749.675,807.148,753.552,807.75,755.9,807.75Z",
    transform: "translate(-624.498 -667.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M793.884,661.051c.835-.409.937-2.212,1.1-2.937.319-1.429,1.857-4.42,2.226-6.757.2-1.276.013-3.369.077-4.593.125-2.446,1.9-4.59,2.752-6.836.438-1.155-.558-1.992-.96-3.066a26.048,26.048,0,0,1-.7-3.321,3.068,3.068,0,0,0-1.753-2.291c-.668-.281-2.262-.783-2.7-.068a14.825,14.825,0,0,0-1.321,3.152c-.721,2.423-.733,7.931-.184,11.354a18.246,18.246,0,0,1,.134,4.066,72.41,72.41,0,0,1-1.282,7.211c-.232.872-1.1,2.107-.943,2.94C790.424,660.459,793,661.487,793.884,661.051Z",
    transform: "translate(-658.352 -525.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M818.379,613.431a3.835,3.835,0,0,0,1.169,1.641,4.541,4.541,0,0,1,.843,1.691c.326.875,1.847,6.151,2.556,7.859a6,6,0,0,0,1.588,2.069c1.837,1.633,5.894,7.621,6.984,9.44.815,1.357,1.241,2.924,1.6,3.239.708.628,2.6-.3,3.161-.8.372-.334,1.1-.91.908-1.636a3.506,3.506,0,0,0-.88-1.513c-1.423-1.434-3.423-6.225-4.264-7.724a27.888,27.888,0,0,0-2.384-3.389c-1.964-2.535-1.044-5.745-1.837-8.662-.239-.88.112-1.256.446-2.064a7.546,7.546,0,0,0,.578-4.007c-.551-2-2.311-3.536-4.471-2.656a26.1,26.1,0,0,0-3.712,1.994c-.456.279-2.231,1.122-2.207,1.753A13.68,13.68,0,0,0,818.379,613.431Z",
    transform: "translate(-681.669 -505.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M824.607,630.978a1.931,1.931,0,0,0,.668,1.444,2.195,2.195,0,0,0,1.524.094,18.019,18.019,0,0,0,2.157-.538c.2-.062.282.249.085.309a7.48,7.48,0,0,1-3.426.6,1.906,1.906,0,0,1-1.336-1.909C824.276,630.771,824.6,630.773,824.607,630.978Z",
    transform: "translate(-686.651 -525.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M766.736,573.187c.733.68.646,1.66,1.815,1.91,1.08.235,1.875-.548,2.885-.623.763-.055,1.782.973,2.067-.07.237-.863-.476-1.306-1.226-1.523a13.408,13.408,0,0,1-2.753-.778,4.007,4.007,0,0,0-2.621-.322c-.4.043-1.9.023-2.045.551C764.752,572.669,766.487,572.956,766.736,573.187Z",
    transform: "translate(-637.146 -476.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M789.692,457.859a4.458,4.458,0,0,0,.835.79,2.963,2.963,0,0,1,.551,1.453c.149.573.594.217,1,.4.472.219.866.825,1.389,1,.581.2.818-.434,1.349-.392.454.035.79.823,1.132,1.072.519.376.756.376,1.2-.032a8.683,8.683,0,0,0,1.06-1.428c1.11-1.561.167-1.9-.569-2.745-1.743-2.017-.077-4.481-2.695-5.941-1.837-1.025-4.857.624-5.594,2.495A2.96,2.96,0,0,0,789.692,457.859Z",
    transform: "translate(-657.261 -376.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M778.234,452.909c.619-.3.658-2.421,1.907-2,.561.189,1.134,1.182,1.78,1.013.429-.114.311-.528.6-.843a.723.723,0,0,1,1.209.224,2.468,2.468,0,0,0,1.6,1.436c1.062.22.76-1.476.718-1.975-.14-1.613-.4-3.917-2.094-4.258-1.366-.276-1.575.157-2.117.157a6.392,6.392,0,0,0-2.586.271c-1.8.8-2.338,1.69-3.191,3.3C775,452.241,777.973,453.034,778.234,452.909Z",
    transform: "translate(-646.297 -371.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M825.873,494.427a9.6,9.6,0,0,0,.09,1.169c.235.643,1.062-.042,1.381-.439a12.938,12.938,0,0,1,1.107-1.66,8.4,8.4,0,0,1,1.312-.813c.436-.272.847-.578.887-1.107.063-.815-.548-.818-1.194-.731a4.961,4.961,0,0,0-2.159,1.049c-.292.2-1.76.942-1.721,1.309C825.62,493.626,825.792,494.013,825.873,494.427Z",
    transform: "translate(-687.73 -408.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M811.408,521.453c.892.334,2.451-.222,3.254-.591,1.611-.738,3.365-2.441,5.47-1.877,1.013.272,2.962,2.61,2.86.8a11.393,11.393,0,0,0-1.017-2.967,6.646,6.646,0,0,1-.551-3.172c.334-2.571.893-4.992.606-7.605-.2-1.863-.544-4.341-1.67-5.917a3.491,3.491,0,0,0-5.248-.634c-1.6,1.352-2.495,4.007-2.87,5.931-.469,2.414.072,4.854-.334,7.261-.2,1.184-.912,2.428-.731,3.637a13.8,13.8,0,0,1,.334,1.464,3.981,3.981,0,0,1-.394,1.564C810.881,520,810.388,521.075,811.408,521.453Z",
    transform: "translate(-675.412 -415.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M828.65,511c.105.244,1,1.289.937.429-.01-.119-.491-.583-.549-.726a3.982,3.982,0,0,1-.149-1.232c-.184-2.516-1.244-6.634,1.952-7.62a2.5,2.5,0,0,1,1.585.107c.578.2,1.3,1.112,1.793,1.429.239.154.451,0,.349-.356a4.348,4.348,0,0,0-1.5-1.6,3.141,3.141,0,0,0-3.43.117,5.509,5.509,0,0,0-2.11,3.932A13.568,13.568,0,0,0,828.65,511Z",
    transform: "translate(-689.345 -417.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M851.991,528.3a9.08,9.08,0,0,0,5.081-.738,4.676,4.676,0,0,0,.942-.594c.635-.469.728-1.92.73-2.688,0-.808-.062-1.64-.035-2.444a7.319,7.319,0,0,0-.364-2.449c-.262-.92-.269-1.837-.467-2.77a6.189,6.189,0,0,0-1.057-2.109,17.607,17.607,0,0,0-3.109-3.789c-.733-.628-2.182-1.107-2.927-.227-.917,1.084-.655,3.54-.688,4.869a18.237,18.237,0,0,1-.858,5.443c-.579,1.723-1.636,3.373-1.586,5.214C847.69,527.415,851.188,528.173,851.991,528.3Z",
    transform: "translate(-706.119 -424.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M878.926,573.553a5.679,5.679,0,0,0,1.93-.569c.354-.235.426-.606.528-1.122a14.376,14.376,0,0,0-.094-3.588,8.6,8.6,0,0,0,.022-2c-.21-.417-.835-.588-1.217-.668a6.125,6.125,0,0,0-2.944.122,2.1,2.1,0,0,0-1.67,1.813,39.548,39.548,0,0,0-.835,4.244C874.408,574.4,877.611,573.811,878.926,573.553Z",
    transform: "translate(-728.597 -471.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M868.278,534.822c.668-1.648,1.476-4.278,3.448-4.6a.114.114,0,0,1,.042,0,.167.167,0,0,1,.085,0c.351.092.473.371.589.711.222.644.262,1.261,1.014,1.483a2.7,2.7,0,0,1,1.064.349,1.643,1.643,0,0,1,.526.775c.08.222-.26.319-.334.1-.361-1-1.277-.594-1.922-1.127a1.592,1.592,0,0,1-.424-.644c-.125-.311-.225-1.169-.583-1.282-1.8.334-2.541,2.815-3.156,4.341C868.532,535.135,868.189,535.041,868.278,534.822Z",
    transform: "translate(-723.29 -441.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M882.637,575.413a1,1,0,0,1-.167-.012,1.234,1.234,0,0,1-.449-.219,1.151,1.151,0,0,0-.718-.274c-.092,0-.167-.2-.023-.209a1.1,1.1,0,0,1,.723.215,1.338,1.338,0,0,0,.668.254,2.65,2.65,0,0,0,.334-.033l.291-.038c.307-.038.624-.134.933-.2a6.417,6.417,0,0,0,1.187-.491,4.082,4.082,0,0,1,1.613-.392c.053,0,.055.082.055.085,0,.028-.01.1-.06.1a4.866,4.866,0,0,0-1.772.523,5.889,5.889,0,0,1-1.406.483c-.112.018-.244.048-.386.08A4.105,4.105,0,0,1,882.637,575.413Z",
    transform: "translate(-734.066 -478.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M751.27,564.641l6.976,2.733.28-.691-6.978-2.733Z",
    transform: "translate(-625.831 -469.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M767.123,568.273c.431-.057.619-.317,1.013-.067.264.167.426.563.658.78a2.423,2.423,0,0,0,.992.549,2.272,2.272,0,0,0,2.075-.306c.628-.514,1.127-.262,1.922.01a17.1,17.1,0,0,0,2.483.823,10.7,10.7,0,0,0,2.838.023c.73-.065,1.636.017,2.054-.62a3.784,3.784,0,0,0,.775-2c-.075-.668-.668-.907-1.267-1.084a11.521,11.521,0,0,0-2.239-.581,5.453,5.453,0,0,0-2.318.706,4.542,4.542,0,0,1-2.2.384,10.162,10.162,0,0,1-1.391-.045,3.766,3.766,0,0,1-1-.414c-1.145-.5-1.3-.429-2.069.094a3.958,3.958,0,0,1-1.451.643c-.352.085-1.538.5-1.7.811C766.066,568.423,767.024,568.285,767.123,568.273Z",
    transform: "translate(-638.318 -471.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M834.972,514.21a1.835,1.835,0,0,0,.179,1.67,4.057,4.057,0,0,0,3.1,1.446c.862.038.905-.115,1.2-.9a9.014,9.014,0,0,0,.608-2.338c.07-.79-.047-1.578.062-2.366.092-.668.264-1.3.334-1.969a6.747,6.747,0,0,0-.234-2.939,2.7,2.7,0,0,0-5.151.22c-.536,1.561.01,2.915.167,4.48A10.674,10.674,0,0,1,834.972,514.21Z",
    transform: "translate(-695.448 -420.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M349.381,621.98a7.535,7.535,0,0,0-1.032-1.155c-.469-.5-4.024-3.385-5.32-4.341a17.348,17.348,0,0,1-1.917-1.67,2.61,2.61,0,0,1-.713-2.054c0-.1-.314-.215-.346-.235a13.1,13.1,0,0,0-3.2-1.618,11.861,11.861,0,0,0-1.486-.312,7.965,7.965,0,0,0-1.631-.259.534.534,0,0,0-.311.2,8.45,8.45,0,0,1-1.484,1.631,7.94,7.94,0,0,0-1.549,2.63c-.775,2.261-1.129,4.421-2.838,6.931a4.434,4.434,0,0,0-1.084,2.171c-.047.875.514,1.177,1.157,1.636a8.484,8.484,0,0,0,3.368,1.279,14.972,14.972,0,0,0,4.174.222,14.276,14.276,0,0,0,4.1-1.2,29.6,29.6,0,0,1,4.667-1.67,19.833,19.833,0,0,1,2.755-.287,6.987,6.987,0,0,0,1.767-.289C349.555,623.244,349.839,622.718,349.381,621.98Z",
    transform: "translate(-271.954 -508.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M333.815,700.068a2.944,2.944,0,0,0,.224-.473c.04-.124.1-.214.035-.22-.394-.048-1.04-.167-1.491-.264-.721-.167-1.726-.668-1.837-.631-.466.124,1.267,1.052,1.626,1.185.307.114,1.07.354,1.349.427A.085.085,0,0,0,333.815,700.068Z",
    transform: "translate(-275.456 -581.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M378.167,695.544c.284-.125-.835-.768-1-.972s-.229-.232-.678-.017a21.759,21.759,0,0,1-3.55,1.307c-.149.038-.152.057-.209.2a6.091,6.091,0,0,1-.623,1.042c-.01.012-.032.068.13.063a11.076,11.076,0,0,0,2.723-.377C375.316,696.691,377.631,695.779,378.167,695.544Z",
    transform: "translate(-309.97 -578.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M435.4,678.588c-.138-.346-.728-.461-1.246-.558a9.642,9.642,0,0,0-4.508.406c-.234.08-.194.167-.132.257a4.007,4.007,0,0,1,.509,1.556.177.177,0,0,0,.19.15c.78-.122,1.893-.145,2.725-.215a5.107,5.107,0,0,0,1.938-.479A.927.927,0,0,0,435.4,678.588Z",
    transform: "translate(-357.757 -564.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M425.6,545.281c.109-.538-.9-1.227-1.075-1.035-.334.366-4.627,5.63-4.687,5.662-.586.314-.815-.571-.955-.942-.182-.484-.521-1.064-.6-.561a2.458,2.458,0,0,1-1.326,2.2c-.471.262-.511.344-.2.783a10.142,10.142,0,0,0,2.525,2.124c.835.416,1.695-.488,2.484-1.417a25.116,25.116,0,0,0,2.5-4.228A18.843,18.843,0,0,0,425.6,545.281Z",
    transform: "translate(-347.01 -453.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M382.681,499.388c-.561-1.284-1.885-1.77-2.5-2.927a2.831,2.831,0,0,1-.175-1.63c.077-.683.444-.835-.043-1.277s-1.01-.624-1.252-1.4c-.142-.454-.212-1.364-.751-1.526-.758-.229-.559.546-.573,1.137-.018.776-.065,1.808-.089,2.586a2.544,2.544,0,0,1-.93,1.815c-.4.4.028.227.514.564a3.925,3.925,0,0,1,1.865,2.1c.715,1.753,1.736,2.358,2.872,2.451C383.4,501.43,383.191,500.561,382.681,499.388Z",
    transform: "translate(-313.388 -408.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M388.793,475.311a2.863,2.863,0,0,0-.167-1.917c-.167-.332-.63-.24-1-.087-1.037.427-1.1,1.4-1.927,2.042a1.031,1.031,0,0,1-1.19.068c-.319-.342-.3-.853-.753-1.09-1.239-.643-1.241,1.4-.611,1.954.468.412.621.2.786.9a4.8,4.8,0,0,0,.5,1.393,2.5,2.5,0,0,0,1.748,1.157c.668.045.952-.668,1.264-1.234a2.441,2.441,0,0,1,.5-.586c.479-.25.446-.2.386-1.107A2.83,2.83,0,0,1,388.793,475.311Z",
    transform: "translate(-318.825 -394.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M416.049,706.541a8.082,8.082,0,0,0-1.035-1.207c-.372-.481-.7-1.232-1.018-1.748a11.745,11.745,0,0,1-1.543-3.005c-.354-1.19-.581-2.366-.868-3.565a26.1,26.1,0,0,0-1.336-4,16.8,16.8,0,0,1-1.142-3.373,8.956,8.956,0,0,0-1.137-3.3,6.03,6.03,0,0,1-1.124-2.393c-.1-.668-.416-2.5-.835-2.4a23.1,23.1,0,0,0-4.1,1.756c-.853.471-.459.489.1.994a20.416,20.416,0,0,1,2.222,2.042,4.233,4.233,0,0,1,.771,2.772,9.341,9.341,0,0,0,1.1,4.156c1.394,2.141,3.226,4.4,3.867,6.472a4.414,4.414,0,0,1,.035,1.9c-.06.4-.334,1.383-.04,1.755.426.526,1.533.224,2.274.905s1.286,1.743,2.276,2.146C414.668,706.517,416.249,706.94,416.049,706.541Z",
    transform: "translate(-334.391 -567.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M459.219,810.6a14.331,14.331,0,0,0-3.182-1.169c-1.585-.292-3.775-3.339-4.193-3.673-.573-.476-.975.04-1.049.491-.122.741.324,1.277.464,1.944a9.994,9.994,0,0,1,.209,2.878h.451a6.6,6.6,0,0,1,.224-1.693c.5-1.082,1.169-.359,1.837.3.7.695,1.109,1.388,2.4,1.388C456.747,811.057,459.924,811.2,459.219,810.6Z",
    transform: "translate(-375.51 -671.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M406.887,684.408l.028-.013a3.667,3.667,0,0,1-.1-.449c-.1-.668-.416-2.5-.835-2.4a23.2,23.2,0,0,0-4.1,1.758c-.855.471-.458.484.109.985a20.281,20.281,0,0,1,2.221,2.044,4.225,4.225,0,0,1,.773,2.772c.035.436.085.906.167,1.379.139-.025.219-.461.252-.725a10.7,10.7,0,0,0-.2-3.652C404.768,684.481,406.108,684.88,406.887,684.408Z",
    transform: "translate(-334.368 -567.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M319.213,703.337a12.439,12.439,0,0,1-4.2.085c-.07-.01-.167.426-.312.668-.746,1.336-2.287,1.979-3.005,3.351a20.3,20.3,0,0,0-1.625,5.927,28.545,28.545,0,0,1-.634,2.87,5.624,5.624,0,0,1-1.177,2.022,1.782,1.782,0,0,0-.19,2.278c.493.933.8,1.514,1.254,2.419.282.556.932,1.62,1.586,1.775.533.127.124-.808.017-1.229-.464-1.837.037-4.084.362-5.911a17.528,17.528,0,0,1,2.064-5.343,29.709,29.709,0,0,1,3.189-5.275,34.758,34.758,0,0,0,2.329-2.89C318.951,703.972,319.308,703.316,319.213,703.337Z",
    transform: "translate(-256.361 -585.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M350.424,703.337a12.451,12.451,0,0,1-4.2.085c-.07-.01-.167.426-.312.668a4.252,4.252,0,0,1-.7.91.284.284,0,0,0,.167.08c.311.02.629-.062.938-.025a.7.7,0,0,1,.581.75,5.842,5.842,0,0,1-.641,1.878c-.266.69-.5,1.439-.812,2.105a2.849,2.849,0,0,0-.2,1.2,20.908,20.908,0,0,1,2.5-4.007,36.334,36.334,0,0,0,2.338-2.89C350.161,703.973,350.518,703.314,350.424,703.337Z",
    transform: "translate(-287.571 -585.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M468.141,516.172c-.1-.611-.588.691-.765.987s-.882-.035-1.214-.2c-.449-.22-.489-.167-.324-.629.1-.282,1.239-1.695,1.042-1.775s-.541.23-.908.79c-.255.387-.778.738-.933,1.336-.115.441-.1.875-.2,1.326a5.1,5.1,0,0,1-.623,1.282.732.732,0,0,0,.1,1c.212.239.668.357.863.117a5.767,5.767,0,0,1,.736-.872c.381-.3.853-.464,1.237-.76a3.765,3.765,0,0,0,.768-1.5A2.551,2.551,0,0,0,468.141,516.172Z",
    transform: "translate(-386.579 -428.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M474.145,508.216l-1.835-.795,2.421-4.1,1.837.668Z",
    transform: "translate(-393.449 -419.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M303.209,802.914c-.137-.4-.825-.668-1.194-.758a3.545,3.545,0,0,1-1.763-.808,7.228,7.228,0,0,1-1.913-3.324c-.115-.459-.1-1.354-.417-1.726-.389-.453-.917.063-1.241.422-.5.558-.351,1.159-.459,1.837a7.773,7.773,0,0,1-.942,2.378l.3.232c.321-.334.76-.925.96-1.114.865-.825,1.3.017,1.688.87.406.9.683,1.855,1.74,2.162C300.309,803.179,303.366,803.373,303.209,802.914Z",
    transform: "translate(-245.977 -663.192)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M339.437,457.092c-.366-2.221-2.6-3.122-4.281-3.214a3.45,3.45,0,0,0-3.014,1.761c-.556.872-.594,1.9-1.533,2.474a13.6,13.6,0,0,1-2.6.768c-1.241.458-1.436,1.169-1.865,2.323-.317.852-.835,1.049-1.574,1.5a3.632,3.632,0,0,0-1.723,2.53,2.8,2.8,0,0,0,1.179,2.7c.967.566,1.862.96,2.232,1.882.219.546.417,1.954,1.65,1.944.791,0,.835-1.718.878-2.254.189-2.69,1.336-3.005,3.506-3.692,2.4-.75,1.563-3.768,1.1-5.136-.167-.5-.648-1.5-.4-1.977.606-1.169,1.3.4,1.513.93a.3.3,0,0,0,.275.21c1.521-.018,2.059-1.616,2.493-2.069a1.176,1.176,0,0,1,1.2-.407c.339.157.344,1.4.509,1.446C339.31,458.9,339.54,457.717,339.437,457.092Z",
    transform: "translate(-268.924 -378.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M335.78,532.48c-.424-1.047-1.129-1.67-1.706-3.022-.257-.6-.816-2.122-1.533-2.321-.983-.274.381.852.558,1.14.324.526.977,1.67.389,2.189-.459.4-1.648.1-2.112-.119-1.082-.5-1.454-1.67-2.047-2.61a9.349,9.349,0,0,0-1.468-1.539.946.946,0,0,0-.8-.3,6.257,6.257,0,0,0-1.878.686,3.971,3.971,0,0,0-1.336,2.962,8.682,8.682,0,0,1-1.381,3.769,40.8,40.8,0,0,0-3.132,5.7,30.257,30.257,0,0,0-1.222,3.725c-.14.479-1.459,2.114-.858,2.479.13.079.483-.063.7-.11.631-.137.857.225,1.034.167.227-.068.2-.64.442-1.064.912-1.569,2.518-3.568,2.964-4.675a10.135,10.135,0,0,1,1.1-2.615c.7-1.02,1.115-.94,2.212-2.179.361-.407.623-1.251,1.065-1.129.306.085.324,1.2.3,2.48a6.581,6.581,0,0,1-.668,2.351c-.356.578-.738,1-.678,1.366.085.533.975.272,2.914.7a12.664,12.664,0,0,1,3.64,1.751c.651.424.763-.571.895-1.534.179-1.322-.09-2.409.11-3.718a2.507,2.507,0,0,1,1.478-1.957A1.863,1.863,0,0,0,335.78,532.48Z",
    transform: "translate(-264.15 -438.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M380.726,561.669a3.455,3.455,0,0,0-1.68,0,3.1,3.1,0,0,1-3.069-1.015c-.488-.479-1.192-1.548-1.67-1.658-.416-.094-.641.269-.835.625-.045.082-.521,1.07-.668,1.414a1.093,1.093,0,0,0-.065.277.374.374,0,0,1,.371-.127c.306.087.324,1.194.3,2.478a6.722,6.722,0,0,1-.586,2.192h.008c.21.786,2.077-1.9,2.515-2.262a2.192,2.192,0,0,1,1.67-.486c.69.058,1.216.558,1.852.643a2.592,2.592,0,0,0,1.014-.013h0a2.752,2.752,0,0,1,1.212-1.119,2.646,2.646,0,0,0,.95-.8C381.524,562.178,381.162,561.809,380.726,561.669Z",
    transform: "translate(-310.504 -465.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M317.109,642.6c-.232-1.057-.584-1.256-.835-2.416a1,1,0,0,0-.93-.751c-.316-.043-.9-.06-1.05.294a.1.1,0,0,0,0,.022,3.322,3.322,0,0,0-.581,1.336,1.315,1.315,0,0,0,.382,1.3,1.707,1.707,0,0,0,1.289.658,1.031,1.031,0,0,0,.451-.2c.566-.354.649.04,1.025.372C317.012,643.373,317.309,643.519,317.109,642.6Z",
    transform: "translate(-261.303 -532.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M386.069,525.7c-1.317,0-3.278-1.408-3.905-2.171a2.5,2.5,0,0,1-.441-.72,1.145,1.145,0,0,1,.023-.885.214.214,0,0,1,.182-.115.226.226,0,0,1,.067.012.2.2,0,0,1,.114.1.22.22,0,0,1,0,.167.77.77,0,0,0-.012.6,2.133,2.133,0,0,0,.376.6,6.362,6.362,0,0,0,3.593,2.03,1.31,1.31,0,0,0,.142,0c.139-.015.177-.075.2-.132a2.115,2.115,0,0,0-.835-1.613.27.27,0,0,1-.055-.087.175.175,0,0,1,.055-.2.2.2,0,0,1,.13-.045.247.247,0,0,1,.125.035c.618.554,1.15,1.479.963,2.029a.593.593,0,0,1-.529.4A1.77,1.77,0,0,1,386.069,525.7Z",
    transform: "translate(-317.922 -434.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M189.245,730.672l-5.572-3.349a1.575,1.575,0,0,1-.538-2.161l8.055-13.4a1.574,1.574,0,0,1,2.161-.538l5.572,3.349Z",
    transform: "translate(-152.37 -592.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M220.87,683.229l.591.356L238.9,654.579a.346.346,0,0,0-.119-.474h0a.344.344,0,0,0-.473.119Z",
    transform: "translate(-183.992 -544.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ar",
    width: 18.782,
    height: 0.172,
    transform: "translate(36.73 138.29) rotate(-58.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ar",
    width: 5.909,
    height: 0.94,
    rx: 0.47,
    transform: "translate(36.328 130.55) rotate(-58.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4.774,
    height: 0.94,
    rx: 0.47,
    transform: "translate(36.622 130.057) rotate(-58.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "t",
    cx: 1.686,
    cy: 1.686,
    r: 1.686,
    transform: "translate(34.94 139.638) rotate(-74.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M216.958,824.44c-.6.356.017,1.217-.432.948a.949.949,0,1,1,.978-1.626c.24.145.212.356.048.466S217.167,824.314,216.958,824.44Z",
    transform: "translate(-179.989 -686.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M306.37,658.44l.868.523,3.005-5.009a.5.5,0,0,0-.167-.7h0a.5.5,0,0,0-.7.167Z",
    transform: "translate(-255.216 -544.119)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketServiceImg);
export default __webpack_public_path__ + "static/media/ticket-service-img.a730bf052cd8a0708655e901d9e59167.svg";
export { ForwardRef as ReactComponent };